import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import PurchaseOrderEdit from '@components/shared/purchaseOrders/PurchaseOrderEdit';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useOperatorPurchaseOrderService } from '@hooks/operator/purchase_orders/useOperatorPurchaseOrderService';
import useRecordMerchantSync from '@hooks/operator/useRecordMerchantSync';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import { useOperatorSupplierService } from '@hooks/operator/suppliers/useOperatorSupplierService';
import { useParams } from 'react-router-dom';

const OperatorPurchaseOrderEdit: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { currentMerchant } = useOperatorData();
  const { handleRecordLoaded, merchantDataLoading } = useRecordMerchantSync();

  // 編輯模式：reference data services 跟著 OperatorDataContext.currentMerchant 走。
  // useRecordMerchantSync 會在 onPurchaseOrderLoaded 被觸發後把 currentMerchant 對齊到 PO 的 merchant，
  // 期間 merchantDataLoading 為 true 擋住表單渲染，避免 supplier / product 下拉短暫顯示前一個 merchant 的清單。
  const effectiveMerchantId = currentMerchant?.id ?? undefined;
  const purchaseOrderService = useOperatorPurchaseOrderService();
  const supplierService = useOperatorSupplierService({ merchantId: effectiveMerchantId });
  const productService = useOperatorProductService({ merchantId: effectiveMerchantId });

  if (id) {
    return (
      <PurchaseOrderEdit
        service={purchaseOrderService}
        supplierService={supplierService}
        productService={productService}
        role="operator"
        onPurchaseOrderLoaded={handleRecordLoaded}
        merchantDataLoading={merchantDataLoading}
      />
    );
  }

  // 新增模式：MerchantSelect 控制 merchant；PO 還不存在，不需要 sync
  return (
    <MerchantSelect>
      <PurchaseOrderEdit
        service={purchaseOrderService}
        supplierService={supplierService}
        productService={productService}
        role="operator"
      />
    </MerchantSelect>
  );
};

export default OperatorPurchaseOrderEdit;
